import React from 'react'
import Header from '../Components/Header';
import Showlist from '../Components/Showlist';
import About from '../Components/About';
import Footer from '../Components/Footer';
import Upcoming from '../Components/Upcoming';
import Showact from '../Components/Showact';
import Partners from '../Components/Partners';
import Supportedasso from '../Components/Supportedasso';
import Liveupdate from '../Components/Liveupdate';
import Testimonial from '../Components/Testimonial';
import slide01 from '../assests/img/aije-2027.jpeg';
import slide03 from '../assests/img/banner-jaipur01.jpeg';
import slide02 from '../assests/img/slide02.jpg';
import { Helmet } from "react-helmet-async";


import Slider from "react-slick";
import Faqhome from '../Components/Faqhome';


function App() {
   
  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

return (
    <div >
     <Helmet>
        <title>Jaipur Silver Show | Aadikaash International</title>
        <meta
          name="description"
          content="Explore the Jaipur Silver Show by Aadikaash International — India’s biggest B2B Silver Jewellery Exhibition showcasing premium silver creations."
        />
        <meta
          name="keywords"
          content="Jaipur Silver Show, Silver Show of India, Silver Jewellery Show in Jaipur, Aadikaash International, Silver Jewellery Exhibition, B2B Silver Show"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}

<div className='main-slider'>
      <Slider {...settings}>
      <div>
       <img src={slide01}/>
      </div>
      <div>
       <img src={slide01}/>
      </div>
    </Slider>


      </div>
<About/>
{/* <Upcoming/> */}
<Liveupdate/>
<Showact/>
<Faqhome/>
<Supportedasso/>

<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<Footer/>
 </div>
)

}

export default App;
